import { api, throwApiError } from "../../../api/api";

// ======================================================================
// API - Shift Base Config (NEW)
// ======================================================================

export type ShiftBaseConfig = {
  uf: string;
  baseValue: string;   // "130.00"
  baseHours: number;   // 9
  updatedAt: string;   // ISO
};

export type StoreShiftBaseConfig = {
  storeId: string;
  uf: string;
  baseValue: string;
  baseHours: number;
  updatedAt: string;   // ISO
};

export type UpsertShiftBaseConfigDto = {
  baseValue: string;   // "150.00" (aceita "150,00")
  baseHours?: number;  // default 9
};

/**
 * GET /scheduling/shift-base-config
 */
export const listShiftBaseConfigsApi = async (
  token: string
): Promise<ShiftBaseConfig[]> => {
  try {
    const { data } = await api.get<ShiftBaseConfig[]>(
      `/scheduling/shift-base-config`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao listar configurações de valor base por UF.");
    throw error;
  }
};

/**
 * GET /scheduling/shift-base-config/:uf
 */
export const getShiftBaseConfigByUfApi = async (
  uf: string,
  token: string
): Promise<ShiftBaseConfig> => {
  try {
    const { data } = await api.get<ShiftBaseConfig>(
      `/scheduling/shift-base-config/${uf}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao buscar configuração de valor base por UF.");
    throw error;
  }
};

/**
 * PUT /scheduling/shift-base-config/:uf
 */
export const upsertShiftBaseConfigApi = async (
  uf: string,
  token: string,
  dto: UpsertShiftBaseConfigDto
): Promise<ShiftBaseConfig> => {
  try {
    const { data } = await api.put<ShiftBaseConfig>(
      `/scheduling/shift-base-config/${uf}`,
      dto,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao criar/atualizar configuração de valor base.");
    throw error;
  }
};

/**
 * GET /scheduling/shift-base-config/store/:storeId
 */
export const getShiftBaseConfigForStoreApi = async (
  storeId: string,
  token: string
): Promise<StoreShiftBaseConfig> => {
  try {
    const { data } = await api.get<StoreShiftBaseConfig>(
      `/scheduling/shift-base-config/store/${storeId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao buscar valor base aplicável para a loja.");
    throw error;
  }
};
